'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@achra/ui/accordion';
import { AnimatedSubtitle } from '@/modules/home/components/animated-subtitle';
import { HOME_FAQ_COLUMNS } from './home-faq-data';
function FaqSection() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <header className="mx-auto mb-12 max-w-2xl text-center sm:mb-14 lg:mb-16"><h2 id="home-faq-heading" className="text-foreground text-3xl font-semibold tracking-tight text-balance sm:text-4xl">Frequently Asked Questions</h2><AnimatedSubtitle className="text-foreground/80 mt-4 text-base leading-relaxed text-pretty sm:text-lg">Everything you need to know.</AnimatedSubtitle></header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="w-full py-16 sm:py-20 lg:py-24" aria-labelledby="home-faq-heading"><div className="container">{t0}<div className="grid grid-cols-1 gap-0 md:grid-cols-2 md:gap-12 lg:gap-16">{HOME_FAQ_COLUMNS.map(_temp2)}</div></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp2(column) {
  return <Accordion key={column[0]?.id ?? "col"} type="multiple" className="w-full">{column.map(_temp)}</Accordion>;
}
function _temp(item) {
  return <AccordionItem key={item.id} value={item.id} className="border-border last:border-b"><AccordionTrigger className="text-foreground items-center py-5 text-left text-[15px] font-semibold hover:no-underline data-[state=open]:pb-3 sm:text-base">{item.question}</AccordionTrigger><AccordionContent className="text-foreground/80 text-[15px] leading-relaxed sm:text-base">{item.answer}</AccordionContent></AccordionItem>;
}
export { FaqSection };